import { DIAMETER_NOMINAL_LABELS, RESISTANCE_LABELS, StrictOmit } from '@enmon/commons';
import { Descriptions } from 'antd';
import {
  installationPositionTranslated,
  orientationTranslated,
  thermalMeasurementTypeTranslated,
} from 'components/Form/meter_details/constants';
import { FormattedMessage, IntlShape } from 'react-intl';
import { MeterDetailThermal } from '@enmon/commons/lib/enmon';
import { MeterDetails as messages } from './messages';

export type ThermalDescriptionsDetails = StrictOmit<MeterDetailThermal, 'flowrate'> & {
  flowrate: { value: MeterDetailThermal['flowrate']; unit?: string } | null;
};

export const getThermalDetailDescriptions = (details: ThermalDescriptionsDetails | undefined, intl: IntlShape) => {
  const {
    diameterNominal,
    flange,
    flowrate,
    installationPosition,
    orientation,
    layLength,
    resistance,
    thermalMeasurementType,
  } = details ?? {};

  return (
    <>
      <Descriptions.Item label={<FormattedMessage {...messages.flange} />}>
        {flange ? <FormattedMessage {...messages.yes} /> : <FormattedMessage {...messages.no} />}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.thermalMeasurementType} />}>
        {thermalMeasurementType && intl.formatMessage(thermalMeasurementTypeTranslated[thermalMeasurementType])}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.orientation} />}>
        {orientation && intl.formatMessage(orientationTranslated[orientation])}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.flowRate} values={{ unit: flowrate?.unit ?? 'Q3' }} />}>
        {flowrate?.value && `${flowrate.value} m${String.fromCharCode(179)}/h`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.layLength} />}>
        {layLength && `${layLength} mm`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.diameterDimensionNominal} />}>
        {diameterNominal && DIAMETER_NOMINAL_LABELS[diameterNominal]}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.resistance} />}>
        {resistance && RESISTANCE_LABELS[resistance]}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.installationPosition} />}>
        {installationPosition && intl.formatMessage(installationPositionTranslated[installationPosition])}
      </Descriptions.Item>
    </>
  );
};
